import React from 'react';
import { useNavigate } from 'react-router-dom';

// Existing stylesheet
import './login.css';

function Login() {
  const navigate = useNavigate();

  return (
    <div className="login-page">
      <header className="login-header">
        <h1>Login</h1>

        {/* Inloggen-knop naar /inloggen */}
        <button
          className="sign-in-btn"
          onClick={() => navigate('/inloggen')}
        >
          Inloggen
        </button>

        {/* Aanmelden-knop naar /Aanmelden */}
        <button
          className="sign-up-btn"
          onClick={() => navigate('/Aanmelden')}
        >
          Aanmelden
        </button>
      </header>
    </div>
  );
}

export default Login;
